// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2T-vm","signatureButtonsRight":"ModalSign_signatureButtonsRight__2dp1Z"};